import { TimeRange, useAvailabilitySheet } from "./store";
import { CirclePlus, X } from "lucide-react";
import { TimeInput } from "@/components/ui/input";

const AvailabilityDay = ({
  day,
  entries,
  setEntries,
}: {
  day?: number;
  entries: TimeRange[];
  setEntries: (entries: TimeRange[]) => void;
}) => {
  const timezone = useAvailabilitySheet((s) => s.timezone);

  const dayName = new Date(0, 0, day ?? 0).toLocaleString("en-US", {
    weekday: "long",
  });

  return (
    <div className="flex items-start justify-start gap-3 w-full">
      {day !== undefined && (
        <div
          className="flex justify-center items-center size-10 bg-secondary rounded-full min-w-10 shrink-0 leading-none"
          title={dayName}
        >
          <p className="text-secondary-foreground font-semibold leading-[0] text-lg select-none">
            {dayName.charAt(0)}
          </p>
        </div>
      )}
      <div className="space-y-1.5">
        {!entries.length ? (
          <div className="h-10 flex items-center justify-start">
            <p>{day !== undefined ? "Unavailable" : "Add your availability"}</p>
          </div>
        ) : (
          entries.map((entry, idx) => (
            <div
              key={`availability-entry-${day}-${idx}`}
              className="flex items-center gap-2"
            >
              <TimeInput
                value={entry.startTime}
                onChange={(e) => {
                  const input = e.target.value.toString();
                  const newEntries: TimeRange[] = [...entries];
                  const originalEntry = newEntries[idx];

                  if (!originalEntry) {
                    return;
                  }

                  const updatedEntry = {
                    ...originalEntry,
                    startTime: input,
                    placeholder: input && originalEntry?.endTime ? false : true,
                  };

                  if (
                    input &&
                    updatedEntry.endTime &&
                    updatedEntry.endTime < input
                  ) {
                    updatedEntry.endTime = input;
                  }

                  newEntries[idx] = updatedEntry;

                  setEntries(newEntries);
                }}
              />
              <span>-</span>
              <TimeInput
                value={entry.endTime}
                onChange={(e) => {
                  const input = e.target.value.toString();
                  const newEntries: TimeRange[] = [...entries];
                  const originalEntry = newEntries[idx];

                  if (!originalEntry) {
                    return;
                  }

                  const updatedEntry = {
                    ...originalEntry,
                    endTime: input,
                    placeholder:
                      input && originalEntry?.startTime ? false : true,
                  };

                  if (
                    input &&
                    updatedEntry.startTime &&
                    updatedEntry.startTime > input
                  ) {
                    updatedEntry.startTime = input;
                  }

                  newEntries[idx] = updatedEntry;

                  setEntries(
                    newEntries.sort((a, b) =>
                      a.startTime.localeCompare(b.startTime),
                    ),
                  );
                }}
              />
              <X
                className="size-4 min-w-4 hover:cursor-pointer hover:opacity-80"
                onClick={() => setEntries(entries.filter((_, j) => j !== idx))}
              />
            </div>
          ))
        )}
      </div>
      <div className="shrink-0 h-10 flex items-center self-end">
        <CirclePlus
          className="size-4 hover:cursor-pointer hover:opacity-80"
          onClick={() =>
            setEntries([
              ...entries,
              {
                startTime: "",
                endTime: "",
                timezone,
                placeholder: true,
              },
            ])
          }
        />
      </div>
    </div>
  );
};

export default AvailabilityDay;
